import React, { useState } from 'react';
import { PageHeader, Card, FormGroup, Input, Select, Button, DataTable, ActionButtons, Badge, SectionDivider } from '../../components/common/UIComponents';
import { BankAccountController, FDController } from '../../controllers';

const banks = ['BANK OF INDIA', 'HDFC BANK', 'CASH'];

// =============================================
// BANK RECONCILIATION PAGE
// =============================================
export function BankReconciliationPage() {
  const [recoType, setRecoType] = useState('Current Year');
  const [selectedBank, setSelectedBank] = useState('');
  const [status, setStatus] = useState('UnCleared');
  const [transType, setTransType] = useState('ALL');

  return (
    <div className="fade-in">
      <PageHeader title="Bank Reconciliation" description="Reconcile bank transactions with statements" />
      <Card>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Select Reco Type">
            <Select value={recoType} onChange={e => setRecoType(e.target.value)} options={['Current Year', 'Opening Reco']} />
          </FormGroup>
          <FormGroup label="Select Bank">
            <Select value={selectedBank} onChange={e => setSelectedBank(e.target.value)} options={banks} placeholder="Select" />
          </FormGroup>
          <FormGroup label="Select Date Type">
            <div className="radio-group">
              {['Posted', 'Clear'].map(t => <label key={t} className="radio-label"><input type="checkbox" defaultChecked={t === 'Posted'} /> {t}</label>)}
            </div>
          </FormGroup>
          <FormGroup label="From Date"><Input type="date" /></FormGroup>
          <FormGroup label="To Date"><Input type="date" /></FormGroup>
          <FormGroup label="Select Status">
            <Select value={status} onChange={e => setStatus(e.target.value)} options={['UnCleared', 'Cleared', 'BOTH (Cleared/Uncleared)', 'Bankslip']} />
          </FormGroup>
          <FormGroup label="From"><Input placeholder="From voucher No" /></FormGroup>
          <FormGroup label="To"><Input placeholder="To voucher No" /></FormGroup>
          <FormGroup label="Transaction Type">
            <Select value={transType} onChange={e => setTransType(e.target.value)} options={['ALL', 'Receipt', 'Payment', 'Contra']} />
          </FormGroup>
          <FormGroup label="Cheque No"><Input placeholder="Cheque No" /></FormGroup>
          <FormGroup label="Set Date to All Records">
            <div style={{ display: 'flex', gap: 8 }}>
              <Input type="date" />
              <Button variant="secondary" size="sm">Reset</Button>
              <Button size="sm">Report</Button>
            </div>
          </FormGroup>
        </div>
        <Button>Search</Button>
      </Card>
    </div>
  );
}

// =============================================
// BANK SLIP PAGE
// =============================================
export function BankSlipPage() {
  const [tab, setTab] = useState('create');
  const [bank, setBank] = useState('BANK OF INDIA--002052363252111');
  const [date, setDate] = useState('');
  const [filterType, setFilterType] = useState('Filter Date Wise');

  const slipData = [
    { id: '4778802', voucher: 9, postedDate: '2025-09-23', chequeDate: '2025-09-23', chequeNo: '654321', amount: 15000.00, bank: 'SBI', branch: 'andheri', flatNo: 'F0301' },
  ];

  const printedSlips = [
    { id: 1, bank: 'BANK OF INDIA', amount: 28590, date: '2025-07-08' },
    { id: 2, bank: 'BANK OF INDIA', amount: 28590, date: '2025-09-15' },
  ];

  return (
    <div className="fade-in">
      <PageHeader title="Bank Slip" description="Generate and manage bank deposit slips" />
      <div className="tabs" style={{ marginBottom: 20 }}>
        <button className={`tab ${tab === 'create' ? 'active' : ''}`} onClick={() => setTab('create')}>Create Bank Slip</button>
        <button className={`tab ${tab === 'view' ? 'active' : ''}`} onClick={() => setTab('view')}>View Printed Bank Slip</button>
      </div>

      {tab === 'create' && (
        <>
          <Card style={{ marginBottom: 20 }}>
            <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
              <FormGroup label="Select Bank">
                <Select value={bank} onChange={e => setBank(e.target.value)} options={['BANK OF INDIA--002052363252111', 'HDFC BANK--678987672']} />
              </FormGroup>
              <FormGroup label="Date Wise">
                <div className="radio-group">
                  {['Filter Date Wise', 'Filter Receipt No Wise'].map(t => <label key={t} className="radio-label"><input type="radio" name="filterMode" checked={filterType === t} onChange={() => setFilterType(t)} /> {t}</label>)}
                </div>
              </FormGroup>
              <FormGroup label="Slip Generation Date" required>
                <Input type="date" value={date} onChange={e => setDate(e.target.value)} />
              </FormGroup>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <Button>Save Bank Slip</Button>
              <Button variant="secondary">Print Bank Slip → Click Here</Button>
            </div>
          </Card>
          <DataTable title="Cheques for Bank Slip"
            columns={[
              { key: 'id', label: 'SrNo' },
              { key: 'voucher', label: 'Voucher', className: 'td-mono' },
              { key: 'postedDate', label: 'Posted Date' },
              { key: 'chequeDate', label: 'Cheque Date' },
              { key: 'chequeNo', label: 'ChequeNo', className: 'td-mono' },
              { key: 'amount', label: 'Amount', render: r => <span className="td-amount credit">₹{r.amount?.toLocaleString('en-IN')}</span> },
              { key: 'bank', label: 'Bank' },
              { key: 'branch', label: 'Branch' },
              { key: 'flatNo', label: 'FlatNo' },
              { key: 'select', label: 'Select', render: () => <input type="checkbox" /> },
            ]}
            data={slipData} onSearch={() => slipData} />
        </>
      )}

      {tab === 'view' && (
        <Card title="Print Bank Slip">
          <div className="form-grid form-grid-2" style={{ marginBottom: 14 }}>
            <FormGroup label="Select Bank">
              <Select value={bank} onChange={e => setBank(e.target.value)} options={['BANK OF INDIA--002052363252111', 'HDFC BANK--678987672']} />
            </FormGroup>
            <FormGroup label="Date Wise">
              <div className="radio-group">
                <label className="radio-label"><input type="radio" name="printDateWise" /> Filter Date Wise</label>
              </div>
            </FormGroup>
          </div>
          <DataTable title="Bank Slips"
            columns={[
              { key: 'id', label: 'SrNo' },
              { key: 'bank', label: 'Bank' },
              { key: 'amount', label: 'Amount', render: r => <span className="td-amount credit">₹{r.amount?.toLocaleString('en-IN')}</span> },
              { key: 'date', label: 'Date' },
              { key: 'print', label: 'Print', render: () => <Button size="sm">Print</Button> },
              { key: 'delete', label: 'Delete', render: () => <Button size="sm" variant="danger">Delete</Button> },
            ]}
            data={printedSlips} onSearch={() => printedSlips} />
        </Card>
      )}
    </div>
  );
}

// =============================================
// IMPORT TRANSACTIONS PAGE
// =============================================
export function ImportTransactionsPage() {
  const uploadSections = [
    { title: 'Upload Member Receipts Excel Data' },
    { title: 'Upload Direct Expenses Transaction Excel Data' },
    { title: 'Upload Vendors Transaction Excel Data' },
    { title: 'Upload Incomes Transaction Excel Data' },
    { title: 'Upload JV Excel Data' },
  ];

  return (
    <div className="fade-in">
      <PageHeader title="Import Transactions" description="Bulk upload transaction data via Excel files" />
      <div style={{ display: 'grid', gap: 16 }}>
        {uploadSections.map((s, i) => (
          <Card key={i} title={s.title}>
            <div style={{ display: 'flex', align: 'center', gap: 12, flexWrap: 'wrap' }}>
              <FormGroup label="Select Excel File">
                <input type="file" accept=".xlsx,.xls" style={{ color: 'var(--text-secondary)', fontSize: '0.8rem' }} />
              </FormGroup>
              <div style={{ fontSize: '0.75rem', color: 'var(--accent-red)', paddingTop: 20 }}>* Max File size : 8MB(8192KB)</div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
              <Button variant="success">Download</Button>
              <Button variant="secondary">Reset</Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

// =============================================
// TRANSFER CLOSING BALANCES PAGE
// =============================================
export function TransferClosingBalancesPage() {
  const [activeTab, setActiveTab] = useState('members');
  const bankRecords = BankAccountController.getAll().map(b => ({ ...b, year: '2025-2026' }));

  const tabs = [
    { id: 'members', label: 'Members' },
    { id: 'bank', label: 'Bank Ledgers' },
    { id: 'tariff', label: 'Tariff Ledgers' },
    { id: 'payment', label: 'Payment / Other Income Ledgers' },
    { id: 'vendors', label: 'Vendors Ledgers' },
  ];

  return (
    <div className="fade-in">
      <PageHeader title="Transfer Closing Balances 2025-2026" description="Transfer closing balances to next financial year" />
      <Card style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 14 }}>
          {['Bank Ledgers', 'Members Ledgers', 'Tariff Ledgers(Billing Charges Heads Regular/Supplementary)', 'Payments/Other Income Ledgers (General Ledgers)', 'Vendor Ledgers'].map(t => (
            <label key={t} className="checkbox-label"><input type="checkbox" /> {t}</label>
          ))}
        </div>
        <Button>Transfer</Button>
      </Card>

      <div className="tabs" style={{ marginBottom: 16 }}>
        {tabs.map(t => <button key={t.id} className={`tab ${activeTab === t.id ? 'active' : ''}`} onClick={() => setActiveTab(t.id)}>{t.label}</button>)}
      </div>

      {activeTab === 'bank' && (
        <DataTable title="Bank Ledgers Opening Balances for 2025-2026"
          columns={[
            { key: 'id', label: '#' },
            { key: 'name', label: 'Bank' },
            { key: 'accountNo', label: 'Account No', className: 'td-mono' },
            { key: 'openingBalance', label: 'Opening Balance', render: r => <span className={`td-amount ${r.openingBalance >= 0 ? 'credit' : 'debit'}`}>₹{Math.abs(r.openingBalance).toLocaleString('en-IN')}</span> },
            { key: 'year', label: 'Year' },
          ]}
          data={bankRecords} onSearch={() => bankRecords} />
      )}

      {activeTab === 'members' && (
        <DataTable title="Members Opening Balances for 2025-2026 (Single Member Transfer)"
          columns={[
            { key: 'id', label: '#' },
            { key: 'login', label: 'Login', render: () => 'ATR101' },
            { key: 'memberName', label: 'Member Name', render: () => 'Ankush Gajanan Ingale' },
            { key: 'flatNo', label: 'Flat No', render: () => 'NA-101' },
            { key: 'prin', label: 'Prin.', render: () => '3881.00' },
            { key: 'int', label: 'Int.', render: () => '0.00' },
            { key: 'gst', label: 'GST', render: () => '0.00' },
            { key: 'total', label: 'Total', render: () => <span className="td-amount credit">₹3,881.00</span> },
            { key: 'billType', label: 'Bill Type', render: () => <Badge color="blue">Regular</Badge> },
            { key: 'transfer', label: 'Transfer', render: () => <Button size="sm">Transfer</Button> },
          ]}
          data={[{ id: 1 }, { id: 2 }]} onSearch={d => d} />
      )}
    </div>
  );
}

// =============================================
// FIXED DEPOSITS PAGE
// =============================================
export function FixedDepositsPage() {
  const [records, setRecords] = useState(FDController.getAll());
  const [form, setForm] = useState({ ledgerName: '', head: '', group: '', subGroup: '', fdDate: '', fdrNo: '', fdAcNo: '', bankName: '', amount: '', fdType: '', months: '', interestRate: '', maturityAmount: '', effectiveDate: '', maturityDate: '', alertDays: '', commitee: '', remark: '' });
  const [editing, setEditing] = useState(null);

  const refresh = () => setRecords(FDController.getAll());

  const handleSubmit = () => {
    if (!form.bankName) return;
    const rec = { ...form, amount: parseFloat(form.amount) || 0, months: parseInt(form.months) || 0 };
    editing ? FDController.update(editing, rec) : FDController.add(rec);
    setForm({ ledgerName: '', head: '', group: '', subGroup: '', fdDate: '', fdrNo: '', fdAcNo: '', bankName: '', amount: '', fdType: '', months: '', interestRate: '', maturityAmount: '', effectiveDate: '', maturityDate: '', alertDays: '', commitee: '', remark: '' });
    setEditing(null); refresh();
  };

  const columns = [
    { key: 'id', label: '#' },
    { key: 'fdDate', label: 'FD Date' },
    { key: 'fdrNo', label: 'FDR No', className: 'td-mono' },
    { key: 'fdAcNo', label: 'FD A/c No', className: 'td-mono' },
    { key: 'amount', label: 'Amount', render: r => <span className="td-amount credit">₹{r.amount?.toLocaleString('en-IN')}</span> },
    { key: 'bank', label: 'Bank', render: r => r.bank || r.bankName },
    { key: 'type', label: 'Type', render: r => <Badge color="blue">{r.type || r.fdType}</Badge> },
    { key: 'months', label: 'Months', className: 'td-mono' },
    { key: 'maturityDt', label: 'Maturity Dt', render: r => {
      const val = r.maturityDt || r.maturityDate;
      const expired = val && new Date(val) < new Date();
      return <span style={{ color: expired ? 'var(--accent-red)' : 'var(--text-primary)' }}>{val}</span>;
    }},
    { key: 'actions', label: 'Edit/Del', render: row => (
      <ActionButtons
        onEdit={() => { setForm({ ledgerName: '', head: '', group: '', subGroup: '', fdDate: row.fdDate || '', fdrNo: row.fdrNo || '', fdAcNo: row.fdAcNo || '', bankName: row.bank || row.bankName || '', amount: row.amount?.toString() || '', fdType: row.type || '', months: row.months?.toString() || '', interestRate: '', maturityAmount: '', effectiveDate: '', maturityDate: row.maturityDt || '', alertDays: '', commitee: '', remark: '' }); setEditing(row.id); }}
        onDelete={() => { FDController.delete(row.id); refresh(); }}
      />
    )},
  ];

  return (
    <div className="fade-in">
      <PageHeader title="FD Registers" description="Manage fixed deposit records and maturity tracking" />

      <div className="stat-grid" style={{ marginBottom: 20 }}>
        <div className="stat-card green">
          <div className="stat-icon green">🏦</div>
          <div className="stat-value">₹{(records.reduce((s, r) => s + (r.amount || 0), 0) / 100000).toFixed(1)}L</div>
          <div className="stat-label">Total FD Amount</div>
        </div>
        <div className="stat-card blue">
          <div className="stat-icon blue">📋</div>
          <div className="stat-value">{records.length}</div>
          <div className="stat-label">Active FDs</div>
        </div>
        <div className="stat-card amber">
          <div className="stat-icon amber">⚠️</div>
          <div className="stat-value">{records.filter(r => { const d = r.maturityDt || r.maturityDate; return d && new Date(d) < new Date(); }).length}</div>
          <div className="stat-label">Matured / Expired</div>
        </div>
      </div>

      <Card title={editing ? 'Edit FD Details' : 'Add New FD Details'} style={{ marginBottom: 20 }}>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Ledger Name" required><Input placeholder="Enter FD Ledger Name" value={form.ledgerName} onChange={e => setForm(p => ({ ...p, ledgerName: e.target.value }))} /></FormGroup>
          <FormGroup label="Account Head"><Select value={form.head} onChange={e => setForm(p => ({ ...p, head: e.target.value }))} options={['Assets', 'Liabilities', 'Incomes', 'Expenses']} placeholder="select" /></FormGroup>
          <FormGroup label="FD Date"><Input type="date" value={form.fdDate} onChange={e => setForm(p => ({ ...p, fdDate: e.target.value }))} /></FormGroup>
          <FormGroup label="FDR No" required><Input placeholder="Enter FDR No" value={form.fdrNo} onChange={e => setForm(p => ({ ...p, fdrNo: e.target.value }))} /></FormGroup>
          <FormGroup label="FD A/C No" required><Input placeholder="Enter FD A/c No" value={form.fdAcNo} onChange={e => setForm(p => ({ ...p, fdAcNo: e.target.value }))} /></FormGroup>
          <FormGroup label="Bank Name" required><Input placeholder="Enter Bank Name" value={form.bankName} onChange={e => setForm(p => ({ ...p, bankName: e.target.value }))} /></FormGroup>
          <FormGroup label="Amount" required><Input type="number" placeholder="Enter Amount" value={form.amount} onChange={e => setForm(p => ({ ...p, amount: e.target.value }))} /></FormGroup>
          <FormGroup label="FD Type" required><Input placeholder="Enter FD Type" value={form.fdType} onChange={e => setForm(p => ({ ...p, fdType: e.target.value }))} /></FormGroup>
          <FormGroup label="Number Of Months" required><Input type="number" placeholder="Enter No of Months" value={form.months} onChange={e => setForm(p => ({ ...p, months: e.target.value }))} /></FormGroup>
          <FormGroup label="Interest Rate" required><Input type="number" placeholder="Enter Interest Rate" value={form.interestRate} onChange={e => setForm(p => ({ ...p, interestRate: e.target.value }))} /></FormGroup>
          <FormGroup label="Maturity Amount" required><Input type="number" placeholder="Enter Maturity Amount" value={form.maturityAmount} onChange={e => setForm(p => ({ ...p, maturityAmount: e.target.value }))} /></FormGroup>
          <FormGroup label="Effective Date"><Input type="date" value={form.effectiveDate} onChange={e => setForm(p => ({ ...p, effectiveDate: e.target.value }))} /></FormGroup>
          <FormGroup label="Maturity Date"><Input type="date" value={form.maturityDate} onChange={e => setForm(p => ({ ...p, maturityDate: e.target.value }))} /></FormGroup>
          <FormGroup label="Alert Days"><Input type="number" placeholder="Enter Maturity Alert Days" value={form.alertDays} onChange={e => setForm(p => ({ ...p, alertDays: e.target.value }))} /></FormGroup>
          <FormGroup label="Remark"><Input placeholder="Enter Remark" value={form.remark} onChange={e => setForm(p => ({ ...p, remark: e.target.value }))} /></FormGroup>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button onClick={handleSubmit}>{editing ? 'Update FD Details' : 'Add New FD Details'}</Button>
          <Button variant="secondary">Refresh</Button>
          {editing && <Button variant="ghost" onClick={() => setEditing(null)}>Cancel</Button>}
        </div>
      </Card>

      <SectionDivider />
      <DataTable title="FD Details" columns={columns} data={records} onSearch={q => FDController.search(q, ['bankName', 'bank', 'fdrNo', 'fdAcNo'])} />
    </div>
  );
}
